import { render, staticRenderFns } from "./ProjectAddress.vue?vue&type=template&id=203d87bc&scoped=true&"
import script from "./ProjectAddress.vue?vue&type=script&lang=js&"
export * from "./ProjectAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203d87bc",
  null
  
)

export default component.exports